import { Component, OnInit, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { AuthentificationService } from '../../authentification/authentification.service';
import { EmailStateService } from 'app/core/services/email-state.service';
import { GlobalService } from 'app/global.service';
import { TranslocoService ,TranslocoModule} from '@ngneat/transloco';
@Component({
  selector: 'app-email-setup-dialog',
  templateUrl: './email-setup-dialog.component.html',
  styleUrls: ['./email-setup-dialog.component.scss'],
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatButtonModule,TranslocoModule ]
})
export class EmailSetupDialogComponent implements OnInit {
  emailForm!: FormGroup;
  showSteps = false;
  loading = false;
  sending = false;
  submittedEmail = '';
  currentEmail = '';
  dialogTitle = 'confirm_email.add_email_title';

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<EmailSetupDialogComponent>,
    private authService: AuthentificationService,
    private snackBar: MatSnackBar,
    private emailState: EmailStateService,
    private globalService: GlobalService,
    private translocoService: TranslocoService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // Disable closing dialog by clicking outside
    this.dialogRef.disableClose = true;
    
    if (data) {
      this.currentEmail = data.currentEmail || '';
      this.dialogTitle = data.title || 'confirm_email.add_email_title';
      this.showSteps = data.showSteps || false;
    } else {
      // fallback to global email state if no data passed
      this.currentEmail = this.emailState.getEmail() || '';
    }
  }

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm(): void {
    this.emailForm = this.fb.group({
      email: [this.currentEmail, [Validators.required, Validators.email]]
    });
  }

  get email() {
    return this.emailForm.get('email');
  }

  get isEmailUnchanged(): boolean {
    return this.emailForm.value.email === this.currentEmail;
  }

  onSubmit(): void {
    if (this.emailForm.valid) {
      this.loading = true;
      const email = this.emailForm.value.email;
      this.submittedEmail = email;

      if(this.isEmailUnchanged) {
        this.loading = false;
        this.showSteps = true;
        return;
      }

      // Update email and send confirmation
      this.authService.updateEmail(email).subscribe(
        () => {
          this.loading = false;
          this.showSteps = true;
          this.currentEmail = email;
          // update global email state so other components reflect the change
          this.emailState.setEmail(email);
          this.snackBar.open(this.translocoService.translate('confirm_email.email_sent_success'),
                            this.translocoService.translate('common.close'),
                            { duration: 5000 });
        },
        (error) => {
          this.loading = false;
          this.snackBar.open( this.translocoService.translate('confirm_email.email_send_error'),
          this.translocoService.translate('common.close'),
          { duration: 5000 });
          console.error('Error updating email:', error);
        }
      );
    }
  }

  resendConfirmation(): void {
    this.sending = true;
    
    // Resend confirmation email
    this.authService.sendConfirmationEmail().subscribe(
      () => {
        this.sending = false;
        this.snackBar.open(this.translocoService.translate('confirm_email.email_sent_success'),
        this.translocoService.translate('common.close'), { duration: 5000 });
      },
      (error) => {
        this.sending = false;
        this.snackBar.open( this.translocoService.translate('confirm_email.email_send_error'),
        this.translocoService.translate('common.close'), { duration: 5000 });
        console.error('Error resending confirmation email:', error);
      }
    );
  }

  editEmail(): void {
    this.showSteps = false;
    this.emailForm.patchValue({ email: this.submittedEmail || this.currentEmail });
  }

  onClose(): void {
    // If the current user exists and email is not confirmed, request the banner
    const user = this.globalService.getUser();
    if (user && this.emailState.getEmail() && user.email_confirmed === false) {
      this.emailState.setShowBanner(true);
    }
    this.dialogRef.close();
  }
}
